import * as helpers from '../helpers';

export default function initSelectCondition() {
    const selectArray = [...document.querySelectorAll('.js-select-condition')];

    selectArray.forEach((select) => {
        const targetValuesObject = JSON.parse(select.getAttribute('data-target-object'));

        const hideAllBlocks = () => {
            [...Object.values(targetValuesObject)].forEach((selector) => {
                const targetBlock = document.querySelector(selector);

                targetBlock.style.display = 'none';
                // helpers.makeBlockUnRequired(targetBlock);
            });
        };

        hideAllBlocks();

        select.addEventListener('change', (_) => {
            hideAllBlocks();

            [...Object.keys(targetValuesObject)].forEach((key) => {
                if (select.value.toString() === key) {
                    const targetBlock = document.querySelector(targetValuesObject[key]);
    
                    if (targetBlock) {
                        targetBlock.style.display = 'block';
                        // helpers.makeBlockRequired(targetBlock);
                    }
                }
            });
        });
    });
}
